/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessInfo
 */
export interface BusinessInfo {
    /**
     * 
     * @type {string}
     * @memberof BusinessInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessInfo
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessInfo
     */
    country_iso_code?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessInfo
     */
    currency_iso_code: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessInfo
     */
    category?: string;
}

/**
 * Check if a given object implements the BusinessInfo interface.
 */
export function instanceOfBusinessInfo(value: object): value is BusinessInfo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('reference' in value) || value['reference'] === undefined) return false;
    if (!('currency_iso_code' in value) || value['currency_iso_code'] === undefined) return false;
    return true;
}

export function BusinessInfoFromJSON(json: any): BusinessInfo {
    return BusinessInfoFromJSONTyped(json, false);
}

export function BusinessInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'reference': json['reference'],
        'country_iso_code': json['country_iso_code'] == null ? undefined : json['country_iso_code'],
        'currency_iso_code': json['currency_iso_code'],
        'category': json['category'] == null ? undefined : json['category'],
    };
}

export function BusinessInfoToJSON(json: any): BusinessInfo {
    return BusinessInfoToJSONTyped(json, false);
}

export function BusinessInfoToJSONTyped(value?: BusinessInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'reference': value['reference'],
        'country_iso_code': value['country_iso_code'],
        'currency_iso_code': value['currency_iso_code'],
        'category': value['category'],
    };
}

